export default "__VITE_ASSET__CIBkMM7Q__"